import Game from "../../Game.js";
import Styler from "../../maze/featurer/Styler.js";
import Spran from "../spran/Spran.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";

export default class Fireplace extends Mob {
	constructor(sprites, cell) {
		super(sprites, Fireplace.ANIMATIONS);
		this.width = Game.FIREPLACE_WIDTH;
		this.height = Game.FIREPLACE_HEIGHT;
		this.cellOccupied = cell;
		cell.blocked = true;
		cell.fireplace = true;
		this.lighted = false;

		let traits = {
			clas: "fireplace",
			openDoors: false,
			static: true,
			qi: BasicAI.QI_NONE,
			speed: Mob.WALK_STEP * Game.MULT,
			radius: Mob.RADIUS,
			runspeed: Mob.RUN_STEP * Game.MULT
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-static").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}


	initSprites() {
		// Setta la grandezza dello sprite
		this.clip = jQuery(".js-sprite", this.mc);

		this.clip.width(Game.FIREPLACE_WIDTH);
		this.clip.height(Game.FIREPLACE_HEIGHT);

		// Lo posiziona, centrato orizzontalmente e appoggiato al bottom verticalmente
		//this.clip.css("left", (this.mc.width() - this.clip.width()) / 2);
		//this.clip.css("top", -(Game.TILE_WIDTH - this.mc.height()) - Game.TILE_WIDTH + Game.HERO_HEIGHT / 2);
		this.spran = new Spran(this.sp, this.clip, this.animationsDefinitions);
		this.spran.init();
		this.setAnimation("off");

	}


	isLit() {
		return this.lighted;
	}

	light() {
		this.setAnimation("on");
		this.lighted = true;
		return []
	}

	setInView(lFlag) {
		if (lFlag) {
			this.spran.resume();
			this.inView = true;
		} else {
			this.spran.pause();
			this.inView = false;
		}
	}

}

Fireplace.ANIMATIONS = [
	{
		id: "off",
		sheet: Styler.FIREPLACE,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 1000
			},
			{
				row: 0,
				col: 1,
				time: 180
			},
			{
				row: 0,
				col: 2,
				time: 180
			},
			{
				row: 0,
				col: 3,
				time: 180
			},
			{
				row: 0,
				col: 4,
				time: 180
			}
		]
	},
	{
		id: "on",
		sheet: Styler.FIREPLACE,
		flip: false,
		frames: [
			{
				row: 1,
				col: 0,
				time: 80,
			},
			{
				row: 1,
				col: 1,
				time: 80,
			},
			{
				row: 1,
				col: 2,
				time: 80,
			},
			{
				row: 1,
				col: 3,
				time: 80,
			},
			{
				row: 2,
				col: 0,
				time: 80,
			},
			{
				row: 2,
				col: 1,
				time: 80,
			},
			{
				row: 2,
				col: 2,
				time: 80,
			},
			{
				row: 2,
				col: 3,
				time: 80,
			},
			{
				row: 3,
				col: 0,
				time: 80,
			},
			{
				row: 3,
				col: 1,
				time: 80,
			},
			{
				row: 3,
				col: 2,
				time: 80,
			},
			{
				row: 3,
				col: 3,
				time: 80,
			}
		]
	},
]